import {Model} from 'MWC';

const daysArr = [1, 21, 31],
    daysArr2 = [2, 3, 4, 22, 23, 24];

export default class extends Model {
    static fields;

    constructor(data, mode) {
        super();

        this.data = data;
        this.mode = mode;
        this._initVariables();
        this._initFields();
    }

    _initVariables() {
        this.creditSum = 10000;
        this.term = 1;
        this.oneTimeTrancheCommission = 0;
        this.trancheCommission = 0;
        this.trancheCost = 0;
    }

    _initFields() {
        this.fields = {
            ...this.data[this.mode]
        };
    }

    changeField(name, value) {
        this[name] = value;

        if (name === 'mode') {
            this._initVariables();
            this._initFields();
        }

        this.calculateIndicators();
    }

    getMonthCommission() {
        return this.fields['month_commission'];
    }

    getCreditRate() {
        return this.fields['rate'];
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getTerms() {
        return this.fields.terms;
    }

    getTerm() {
        return +this.term;
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getDay() {
        const day = this.getTerm();
        if (daysArr.find(el => el === day)) {
            return 'CALCULATOR_DAY';
        } else if (daysArr2.find(el => el === day)) {
            return 'CALCULATOR_DAYS_01';
        } else {
            return 'CALCULATOR_DAYS';
        }
    }

    findAverageRepayment() {
        const creditSum = this.getCreditSum(),
            monthCommission = this.getMonthCommission();
        return +(Math.round(creditSum * monthCommission) / 100);
    }

    findAverageRatePayment() {
        const creditSum = this.getCreditSum(),
            term = this.getTerm(),
            rate = this.getCreditRate();
        return +(((creditSum * (rate / 100)) / 360) * term).toFixed(2);
    }

    findAverageSum() {
        return +(this.findAverageRepayment() + this.findAverageRatePayment()).toFixed(2);
    }

    calculateIndicators() {}
}
